import { isAxiosError } from 'axios'
import { addBot, createGame, startGame } from '@/shared/game/api'
import { createLocalGame } from '@/shared/local/store'
import type { Prefs } from './prefs'

/**
 * Партия с компьютером — одним вызовом: создать стол, посадить соперников,
 * начать. Показывать человеку лобби, в котором он ждёт самого себя, незачем.
 *
 * Нет связи — партия заводится на этом же устройстве: компьютер играет и в
 * браузере (features/local), а «не удалось создать партию» в метро выглядит
 * как сломанная игра. Отказ сервера (409 — есть незаконченная партия и т.п.)
 * при этом пробрасывается: это не про связь, и решать его должен тот, кто
 * звал.
 */
export async function startWithBots(name: string, prefs: Prefs): Promise<string> {
  try {
    const game = await createGame(name, 'private', prefs.variant)

    // Соперников на одного меньше, чем мест: одно из них своё.
    for (let seat = 1; seat < prefs.seats; seat++) {
      await addBot(game.id, prefs.level)
    }

    await startGame(game.id)

    return game.id
  } catch (error) {
    if (isAxiosError(error) && error.response === undefined) {
      return createLocalGame(prefs.seats, prefs.level, prefs.variant)
    }

    throw error
  }
}
